export const NEW_BUSINESS_NOTIFICATION = 'NEW_BUSINESS_NOTIFICATION'
export const NEW_PROFILE_NOTIFICATION = 'NEW_PROFILE_NOTIFICATION'
export const NEW_NETWORK_NOTIFICATION = 'NEW_NETWORK_NOTIFICATION'
export const DELETE_PROFILE_NOTIFICATION = 'DELETE_PROFILE_NOTIFICATION'
export const MARK_PROFILE_NOTIFICATION = 'MARK_PROFILE_NOTIFICATION'
export const UPDATE_ALBUM = 'UPDATE_ALBUM'